import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes, fontWeights, spacing } from './theme';
export const StyledBaseButton = styled.button `
  padding: 0;
  background: transparent;
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ color }) => colors[color] || undefined};
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  font-size: ${({ fontSize }) => fontSize ? fontSizes[fontSize] : fontSizes.regular}px;
  font-weight: ${({ fontWeight }) => { var _a; return (_a = fontWeights[fontWeight]) !== null && _a !== void 0 ? _a : fontWeights.bold; }};
  text-align: ${({ textAlign }) => textAlign !== null && textAlign !== void 0 ? textAlign : 'center'};
  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : undefined)};
`;
export const StyledPrimaryButton = styled(StyledBaseButton) `
  width: 100%;
  padding: ${spacing.base}px;
  background-color: ${({ disabled }) => disabled ? colors.grey : colors.cyanBlue};
  border: 0;
  border-radius: 4px;
  color: ${colors.white};
  text-transform: uppercase;

  @media ${mediaQueries.greaterThanMedium} {
    width: auto;
    min-width: 220px;
  }
`;
export const StyledSecondaryButton = styled(StyledBaseButton) `
  color: ${({ color }) => { var _a; return (_a = colors[color]) !== null && _a !== void 0 ? _a : colors.cyanBlue; }};
  padding: 0 ${spacing.large}px;
  min-width: 120px;
`;
export const StyledCloseButton = styled(StyledBaseButton) `
  background: none;
  border: 0;
  color: ${colors.trueBlack};
  font-size: ${fontSizes.medium}px;
  line-height: 1;
  opacity: 0.6;
  padding: 0;
  height: 24px;
  width: 24px;
  min-width: unset;

  &:hover,
  &:focus {
    opacity: 1;
  }

  > svg {
    outline: none;
  }
`;
//# sourceMappingURL=buttons.js.map